import React, { useEffect, useState } from "react";
import { Link, Route, Routes } from "react-router-dom";
import Search from "./pages/Search";
import RunDetail from "./pages/RunDetail";
import Login from "./pages/Login";
import { UIProvider, useUI } from "./components/UI";
import { api, getToken, setToken } from "./api";

export default function App() {
  // null = still checking whether the backend wants a login
  const [authRequired, setAuthRequired] = useState(null);
  const [token, setTok] = useState(getToken());

  useEffect(() => {
    api
      .get("/auth/status")
      .then(({ data }) => setAuthRequired(!!data?.auth_required))
      .catch(() => setAuthRequired(false));
  }, []);

  const onLogin = (t) => {
    setToken(t);
    setTok(t);
  };
  const logout = () => {
    setToken("");
    setTok("");
  };

  if (authRequired === null) return null;
  if (authRequired && !token) {
    return (
      <UIProvider>
        <Login onLogin={onLogin} />
      </UIProvider>
    );
  }

  return (
    <UIProvider>
      <nav className="nav">
        <Link to="/" className="brand">
          <img
            className="brand-logo"
            src={`${process.env.PUBLIC_URL}/instamatch_logo.svg?v=3`}
            alt=""
          />
          <span className="brand-name">instamatch</span>
        </Link>
        <span className="muted nav-tag">Find public Instagram accounts by describing them</span>
        <div className="spacer" />
        <ModeToggle />
        {authRequired && (
          <button className="btn" onClick={logout}>Sign out</button>
        )}
      </nav>
      <div className="container">
        <Routes>
          <Route path="/" element={<Search />} />
          <Route path="/runs/:id" element={<RunDetail />} />
        </Routes>
      </div>
    </UIProvider>
  );
}

function ModeToggle() {
  const { mode, setMode } = useUI();
  return (
    <div className="seg" role="group" aria-label="View">
      {["simple", "advanced"].map((m) => (
        <button key={m} className={mode === m ? "on" : ""} onClick={() => setMode(m)}>
          {m === "simple" ? "Simple" : "Advanced"}
        </button>
      ))}
    </div>
  );
}
